import { RandomUtil } from "@lib/titan2/dist/util/random/RandomUtil";
import { Point } from "pixi.js";
/**
 * A series of Math utils
 */
export class GameMathUtil {
    constructor() { }
    /**
     * Lerps from initial to a final value based on some progress
     * @param progress in range [0,1]
     * @returns in range [initial, final]
     */
    static lerp(initial, final, progress) {
        return initial + (final - initial) * progress;
    }
    /**
     * Lerps from a range's min to max value based on some progress
     * @param progress in range [0,1]
     * @returns in range [range.min, range.max]
     */
    static lerpMinMax(minMax, progress) {
        return this.lerp(minMax.min, minMax.max, progress);
    }
    /**
     * Get the min and max value of an array
     */
    static toMinMax(elements, numberGenerator) {
        let min = Number.MAX_VALUE;
        let max = Number.MIN_VALUE;
        elements.forEach(x => {
            const number = numberGenerator(x);
            min = Math.min(min, number);
            max = Math.max(max, number);
        });
        return { min, max };
    }
    static add(a, b) {
        return new Point(a.x + b.x, a.y + b.y);
    }
    /**
     * Returns a random point in a circle with a radius and a center
     */
    static randomPointInCircle(radius, center, minRadius) {
        minRadius ?? (minRadius = 0);
        center ?? (center = new Point());
        const r = this.lerp(minRadius, radius, RandomUtil.nextDouble());
        const angle = this.lerp(0, 2 * Math.PI, RandomUtil.nextDouble());
        return new Point(center.x + r * Math.cos(angle), center.y + r * Math.sin(angle));
    }
}
//# sourceMappingURL=GameMathUtil.js.map